import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'

const StyledLoaderWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
}))

const ChartLoader = () => {
  return (
    <StyledLoaderWrapper>
      <CircularProgress />
    </StyledLoaderWrapper>
  )
}
export default ChartLoader
